import React from "react";
import { useSelector } from "react-redux";
import { shallowEqual } from "recompose";
import CrudLayoutContainer from "src/components/crud-layout-component/CrudLayoutContainer";
import RoutingUtil from "src/utils/RoutingUtil";
import { PRODUCT_CATEGORY_TYPES } from "src/containers/product-container/ProductConstants";
import UsePermission from "src/hoc/UsePermission";
import CaseForm from "./CaseForm";
import VehicleInsuranceQuotationForm from "./components/VehicleInsuranceQuotationForm";
import VehicleInsuranceCoverNoteForm from "./components/VehicleInsuranceCoverNoteForm";
import VehicleInsurancePaymentsForm from "./components/VehicleInsurancePaymentsForm";
import CoApplicantForm from "./components/CoApplicantForm";
import CaseSearchWithFilter from "./CaseSearchWithFilter";

const data = [
  {
    link: RoutingUtil.caseManagerUrl(),
    title: "Manage", // tab title
    component: CaseForm,
  },
  {
    link: RoutingUtil.caseSearch(),
    title: "Search", // tab title
    component: () => (
      <CaseSearchWithFilter />
    ),
  },
];

const CaseContainer = () => {
  const { currentRecord } = useSelector(
    (state) => state.CaseReducer,
    shallowEqual
  );

  const viewVehicleInsuranceQuotationPermission = UsePermission({
    scope: "flow.case_manager.vehicle_insurance_quotations.view",
  });
  const viewVehicleInsuranceCoverNotesPermission = UsePermission({
    scope: "flow.case_manager.vehicle_insurance_cover_notes.view",
  });
  const viewVehicleInsurancePaymentsPermission = UsePermission({
    scope: "flow.case_manager.vehicle_insurance_payments.view",
  });

  const tabs = [...data];

  if (
    currentRecord?.productCategory === PRODUCT_CATEGORY_TYPES.VEHICLE_INSURANCE
  ) {
    if (viewVehicleInsuranceQuotationPermission) {
      tabs.push({
        link: RoutingUtil.caseVehicleQuotationUrl(),
        title: "Vehicle Ins. Quotations", // tab title
        component: VehicleInsuranceQuotationForm,
      });
    }

    if (viewVehicleInsuranceCoverNotesPermission) {
      tabs.push({
        link: RoutingUtil.caseVehicleCoverNoteUrl(),
        title: "Insurance Policy Details", // tab title
        component: VehicleInsuranceCoverNoteForm,
      });
    }

    if (viewVehicleInsurancePaymentsPermission) {
      tabs.push({
        link: RoutingUtil.caseVehicleInsurancePaymentUrl(),
        title: "Vehicle Ins. Payments", // tab title
        component: VehicleInsurancePaymentsForm,
      });
    }
  } else if (
    currentRecord?.productCategory === PRODUCT_CATEGORY_TYPES.CAR_LOAN
  ) {
    if (viewVehicleInsuranceQuotationPermission) {
      tabs.push({
        link: RoutingUtil.CoApplicants(),
        title: "Co Applicants", // tab title
        component: CoApplicantForm,
      });
    }
  }

  return <CrudLayoutContainer title="Case Manager" tabs={tabs} routes={tabs} />;
};

export default CaseContainer;
